import React, { useCallback, useMemo, useState } from 'react';
import { useDimensions } from '@noths/polaris-client-react-hooks';
import {
  IconUserMember,
  IconUserOutlined,
  IconUserSolid,
} from '@noths/polaris-client-ribbons-design-system';

import { IconBarItem, IconBarItemLabel } from './IconBarItem';
import * as styles from './IconBar.styles';
import { AccountPopover } from 'client-site-chrome-ui/components/molecules/AccountPopover/AccountPopover';
import { useUserContext } from 'client-site-chrome-ui/context/UserContext/useUserContext';

export const MyAccount = () => {
  const { membershipIsActive, userAuthenticated } = useUserContext();
  const { dimensions: accountIconDimensions, ref: accountIconRef } = useDimensions();
  const [isAccountPopoverOpen, setAccountPopoverOpen] = useState(false);
  const href = userAuthenticated ? '/user/orders' : '/u/sign-in';
  const position = useMemo(
    () => ({
      x: accountIconDimensions.x + accountIconDimensions.width / 2,
      y: accountIconDimensions.bottom,
    }),
    [accountIconDimensions.x, accountIconDimensions.width, accountIconDimensions.bottom],
  );

  const onMyAccountClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setAccountPopoverOpen(true);
  }, []);

  const onCloseHandler = useCallback(() => setAccountPopoverOpen(false), []);

  return (
    <IconBarItem>
      <a
        css={[styles.link, isAccountPopoverOpen && styles.focusedLink]}
        href={href}
        onClick={onMyAccountClick}
        ref={isAccountPopoverOpen ? accountIconRef : null}
      >
        {userAuthenticated && membershipIsActive ? (
          <IconUserMember css={[styles.icon]} />
        ) : userAuthenticated ? (
          <IconUserSolid css={styles.icon} />
        ) : (
          <IconUserOutlined css={styles.icon} />
        )}
        <IconBarItemLabel>My Account</IconBarItemLabel>
      </a>
      <AccountPopover isOpen={isAccountPopoverOpen} onClose={onCloseHandler} position={position} />
    </IconBarItem>
  );
};
